module.exports = __webpack_public_path__ + "74775229abaa404f4ed2eff463b95841.svg";